import { useMaskInput } from 'use-mask-input';

const CustomInput = (
  { onFocus, value, disabled, className, onChange }: { onFocus?: any; value?: any; disabled?: boolean; className?: string; onChange?: any }
) => {
  const ref = useMaskInput({ mask: '99/99/9999' });
  return (
    <input
      id="date"
      name="date"
      ref={ref}
      placeholder="mm/dd/yyyy"
      onFocus={onFocus}
      value={value.toString()}
      className={className}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

export default CustomInput;
